import { realpath } from 'fs';
import { createTypePredicateNodeWithModifier } from 'typescript';
import UnityEnvironment from '../core/Components/Environments/UnityEnvironment';
import GameManager from '../core/GameManager';
import Scenario from '../core/Scenario';
import Store from '../core/Store';
import { constants, Globals, ILaunchedScenario, isios, launchedScenarioStore } from './helpers';

export default class BleedingControlScenario extends Scenario {
	constructor(gameManager: GameManager, scenarioName: string, public scenarioSceneToLoad: ScenarioSceneType,
		protected endAt: ScenarioEndType, protected stepsToSkip?: StepToSkip[], isSufficient?: boolean, shownPercentage?: number, shownPercentage2?: number, aarPPE?: boolean, aarPD?: boolean, aarTourn1?: boolean, aarTourn2?: boolean) {
		super(gameManager, scenarioName);
		if (isSufficient)
			this.isSufficient = isSufficient;
		if (shownPercentage)
			this.shownPercentage = shownPercentage;
		if (shownPercentage2)
			this.shownPercentage2 = shownPercentage2;
	}

	public get totalNumberOfQuestions(): number {
		throw new Error('totalNumberOfQuestions must be implemented');
	}

	public setScenarioPassed(passed: boolean) {
		const store = new Store();
			let launchedScenario = JSON.parse(store.get(launchedScenarioStore)) as ILaunchedScenario;
			if(launchedScenario){
				launchedScenario.isCompleted = passed;
				store.set(launchedScenarioStore, JSON.stringify(launchedScenario));
			}
	}

	public stopBleeding() {
		var context = this;
			context.playSequence('StopBleeding', null, () => {
			});
	}

	public aarPassed: boolean;
	public aarPDScenarioD: boolean;
	public aarCalled911: boolean;
	public aarWearPPE: boolean;
	public aarPressureDressing: boolean;
	public aarApplyPressureDressing: boolean;
	public aarApplyPressureWithPD: boolean;
	public aarPressureDressingNotRemoved: boolean;
	public aarReassessAfterPD: boolean;
	public aarApplyFirstTourniquete: boolean;
	public aarTwistFirstTourniqueteRod: boolean;
	public aarReassessAfterFirstTourniquete: boolean;
	public aarRecordTimeOfFirstTourniquete: boolean;
	public aarApplySecondTourniquete: boolean;
	public aarTwistScondTourniqueteRod: boolean;
	public aarReassessAfterSecondTourniquete: boolean;
	public aarRecordTimeOfSecondTourniquete: boolean;
	public questionsAnsweredCorrectly: any = {};
	public isSufficient: boolean = false;
	public shownPercentage: number = null;
	public shownPercentage2: number = null;
	private store = new Store();

	public getAARData(): AARData {
		var scenarioTitle = this.scenarioSceneToLoad.toString();

		switch (scenarioTitle) {
			case '0':
				scenarioTitle = 'A';
				break;
			case '1':
				scenarioTitle = 'B';
				break;
			case '2':
				scenarioTitle = 'C';
				break;
			case '3':
				scenarioTitle = 'D';
				break;
		}

		return {
			scenario: scenarioTitle[scenarioTitle.length - 1],
			passed: this.aarPassed,
			score: this.completionPercentage,
			time: this.completionTime,
			currentScenario: this.scenarioSceneToLoad,
			actionItems: [
				{
					title: 'Pressure Dressing avoided for patient safety.',
					correctFeedback: 'You successfully avoided using the pressure dressing for the safety of the patient.',
					incorrectFeedback: 'You used the pressure dressing on a severe and fragile wound. Pressure dressing should be avoided for wounds of this type.',
					showInScenarios: [
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarPDScenarioD
				},
				{
					title: 'Assess the area and ask a bystander to call 911.',
					correctFeedback: 'You successfully assessed the area and asked a bystander to call 911.',
					incorrectFeedback: 'You did not ask the bystander to call 911.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarCalled911
				},
				//aar for safe location?
				{
					title: 'Wear personal protective equipment.',
					correctFeedback: 'You successfully wore your personal protective equipment.',
					incorrectFeedback: 'You did not wear your personal protective equipment.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarWearPPE
				},
				{
					title: 'Identify appropriate pressure dressing.',
					correctFeedback: 'You successfully located and used the appropriate pressure dressing.',
					incorrectFeedback: 'You did not locate/use the appropriate pressure dressing.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						// ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarPressureDressing
				},
				{
					title: 'Apply the pressure dressing over the wound.',
					correctFeedback: 'You successfully identified the wound location and applied the pressure dressing over the wound.',
					incorrectFeedback: 'You did not apply the pressure dressing over the wound.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						// ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarApplyPressureDressing
				},
				{
					title: 'Apply Pressure to the wound with the pressure dressing.',
					correctFeedback: 'You successfully applied pressure to the wound.',
					incorrectFeedback: 'You did not apply pressure to the wound.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						// ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarApplyPressureWithPD
				},
				{
					title: 'If the bleeding is not controlled, don’t remove the dressing.',
					correctFeedback: 'You successfully kept the dressing in place.',
					incorrectFeedback: 'You did not keep the dressing in place.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						// ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarPressureDressingNotRemoved
				},
				{
					title: 'Reassess for Bleeding Control – after pressure dressing.',
					correctFeedback: 'You successfully assessed the bleeding and took the appropriate next step.',
					incorrectFeedback: 'You did not assess the bleeding and did not take the appropriate next step.',
					showInScenarios: [
						ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						// ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarReassessAfterPD
				},
				{
					title: 'Identify and apply the 1st tourniquet on the correct location.',
					correctFeedback: 'You successfully applied the tourniquet on the correct location.',
					incorrectFeedback: 'You did not apply the tourniquet on the correct location.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarApplyFirstTourniquete
				},
				{
					title: 'Twist the Rod until the bleeding has stopped.',
					correctFeedback: 'You successfully twisted the rod on the tourniquet to stop the bleeding.',
					incorrectFeedback: 'You did not twist the rod on the tourniquet to stop the bleeding.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarTwistFirstTourniqueteRod
				},
				{
					title: 'Reassess for Bleeding Control – after 1st tourniquet.',
					correctFeedback: 'You successfully assessed the bleeding and took the appropriate next step.',
					incorrectFeedback: 'You did not assess the bleeding and took the appropriate next step.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarReassessAfterFirstTourniquete
				},
				{
					title: 'Record time of application of 1st tourniquet.',
					correctFeedback: 'You successfully recorded the time of application of the tourniquet.',
					incorrectFeedback: 'You did not record the time of application of the tourniquet.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarRecordTimeOfFirstTourniquete
				},
				{
					title: 'Identify and apply the 2nd tourniquet on the correct location.',
					correctFeedback: 'You successfully applied the tourniquet on the correct location.',
					incorrectFeedback: 'You did not apply the tourniquet on the correct location.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						// ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarApplySecondTourniquete
				},
				{
					title: 'Twist the Rod until the bleeding has stopped.',
					correctFeedback: 'You successfully twisted the rod on the tourniquet to stop the bleeding.',
					incorrectFeedback: 'You did not twist the rod on the tourniquet to stop the bleeding.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						// ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarTwistScondTourniqueteRod
				},
				{
					title: 'Reassess for Bleeding Control – after 2nd tourniquet.',
					correctFeedback: 'You successfully assessed the bleeding and took the appropriate next step.',
					incorrectFeedback: 'You did not assess the bleeding and took the appropriate next step.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						// ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarReassessAfterSecondTourniquete
				},
				{
					title: 'Record time of application of 2nd tourniquet.',
					correctFeedback: 'You successfully recorded the time of application of the tourniquet.',
					incorrectFeedback: 'You did not record the time of application of the tourniquet.',
					showInScenarios: [
						// ScenarioSceneType.scenarioA,
						// ScenarioSceneType.scenarioB,
						ScenarioSceneType.scenarioC,
						ScenarioSceneType.scenarioD
					],
					isCorrect: this.aarRecordTimeOfSecondTourniquete
				}
			]
		};
	}

	public get completionPercentage(): number {
		var length = 0;
		for (var prop in this.questionsAnsweredCorrectly) {
			if (this.questionsAnsweredCorrectly.hasOwnProperty(prop)) {
				length++;
			}
		}
		return Math.floor((length / this.totalNumberOfQuestions) * 100);
	}

	public get completionTime(): string {
		var time = +this.store.get('secondsPassed-BC');
		var minutes: any = Math.floor(time / 60);
		var seconds: any = time - minutes * 60;

		if (minutes >= 4 || minutes === '04') {
			seconds = '00';
		}
		else if (seconds < 10) {
			seconds = '0' + seconds;
		}
		return minutes + ':' + seconds;
	}

	public onAnsweredCorrectly(questionId: string, onDone: () => any) {
		this.questionsAnsweredCorrectly[questionId] = true;
		onDone();
	}

	public soundFolderAndPath(section: string, part: string): string {
		throw new Error('soundFolderAndPath must be implemented');
	}

	public playSound(section: string, part: string, onDone?: () => void, oneShot?: boolean, muted?: boolean): void {
		this.gameManager.SoundManager.stopAllSounds();
		var context = this;
		context.gameManager.SoundManager.playSound({
			src: 'assets/audio/' + this.soundFolderAndPath(section, part) + '.mp3',
			onEnded: onDone,
			oneShot: typeof oneShot === 'undefined' ? true : oneShot,
			playsInline: true,
			autoPlay: true,
			enableClosedCaptioning: true,
			muted: muted
		});
	}

	public loadTutorialScene(onDone: () => void) {
		this.smartLoad('practice_scene', 'practicescenecode', onDone);
	}

	public loadParkingGarageScene(codeScene: string, onDone: () => void) {
		this.smartLoad('A_Parking_Garage', codeScene, onDone);
	}

	public loadOutsideVAScene(codeScene: string, onDone: () => void) {
		if (isios()) {
			switch (codeScene) {
				case 'scenariob':
					this.smartLoad('B_Outside_VA', codeScene, onDone);
					break;
				case 'scenariod':
					this.smartLoad('D_Outside_VA', codeScene, onDone);
					break;
			}
		} else {
			this.smartLoad('B_Outside_VA', codeScene, onDone);
		}
	}

	public loadLobbyVAScene(codeScene: string, onDone: () => void) {
		this.smartLoad('C_Lobby_VA', codeScene, onDone);
	}

	private smartLoad(graphicScene: string, codeScene: string, onDone: () => void) {
		var scenes = [
			graphicScene + '.' + (isios() ? 'sd' : 'hd'),
			codeScene + '.hd'
		];

		console.log('Loading ' + JSON.stringify(scenes));
		this._loadScenes(scenes, onDone);
	}

	public showJITFeedback(msg: string, onNext: () => void) {
		if (!this.gameManager || !this.gameManager.UiManager) {
			return;
		}
		this.gameManager.UiManager.hideaAllUis();
		this.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {
			isCorrect: false,
			message: msg
		});

		setTimeout((context) => {
			context.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
			onNext();
		}, 5000, this);
	}

	public changeArea(areaName: string, onDone: () => void): void {
		this.playSequence('ChangeArea', {
			areaName: areaName
		}, onDone);
	}

	public playSequence(name: string, props?: any, onDone?: () => void, onError?: () => void): void {
		this.gameManager.customData.dispatch({
			type: 'playSequence',
			value: {
				sequenceName: name,
				props: {
					onDone: onDone,
					onError: onError,
					sequenceProps: props
				},
				skipAnimations: Globals.skipAnimations
			}
		});
	}

	private _loadScenes(sceneNames: string[], onDone: () => void): void {
		var context = this;
		context.gameManager.environment.onLoadingScene();
		setTimeout(() => {
			context.playSequence('LoadSceneInteraction', {
				scenes: sceneNames.join(';'),
				assetBundleDir: process.env.PUBLIC_URL + '/static/unity-build/AssetBundles/'
			}, () => {
				context.gameManager.environment.onSceneLoaded();
				if (onDone) {
					onDone();
				}
			});
		}, 1000);
		
	}

	public rotateCamera(onIsSufficient: () => void, onIsNotSufficient: () => void) {
		var prevPercentage = 50;

		var context = this;
		if (!context.gameManager || !context.gameManager.UiManager) {
			return;
		}
		context.gameManager.UiManager.showUi(constants.InGameUINames.RotateCamera, {
			dispatch: context.gameManager.customData.dispatch,
			onUpdate: (percentage: number) => {
				if (prevPercentage === percentage) {
					return;
				}

				prevPercentage = percentage;
				if (this.isSufficient && percentage >= this.shownPercentage && percentage <= this.shownPercentage2) {
					return;
				} else if (!this.isSufficient && (percentage < this.shownPercentage || percentage > this.shownPercentage2)) {
					return;
				}

				if (percentage >= this.shownPercentage && percentage <= this.shownPercentage2) {
					this.isSufficient = true;
					onIsSufficient();
				} else {
					this.isSufficient = false;
					onIsNotSufficient();
				}
			}
		});
	}
}

export class AARData {
	scenario: string;
	passed: boolean;
	currentScenario: ScenarioSceneType;
	time: string;
	score: number;
	actionItems: AARActionItem[];
}

export class AARActionItem {
	title: string;
	isCorrect: boolean;
	correctFeedback: string;
	incorrectFeedback: string;
	showInScenarios: ScenarioSceneType[];
}

export enum ScenarioEndType {
	pressureDressing,
	firstTourniquete,
	end
}

export enum ScenarioSceneType {
	scenarioA,
	scenarioB,
	scenarioC,
	scenarioD,
	Tutorial
}

export enum StepToSkip {
	steps3And4And5And6
}